import React, { useEffect, useState } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  onSelect: (estimateId: number) => void;
}

export default function EstimateSelectModal({ open, onClose, onSelect }: Props) {
  const [estimates, setEstimates] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    (window as any).api.estimate.list({ status: 'issued' })
      .then((res: any) => setEstimates(Array.isArray(res) ? res : (res?.data || [])))
      .finally(() => setLoading(false));
  }, [open]);

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }} onClick={onClose}>
      <div style={{
        background: '#fff', padding: 20, borderRadius: 8, width: 720, maxHeight: '80vh', overflow: 'auto'
      }} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ marginTop: 0 }}>発行済み見積を選択</h2>
        {loading && <p>読込中...</p>}
        {!loading && estimates.length === 0 && <p>該当する見積がありません</p>}
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#e5e7eb' }}>
              <th style={{ padding: 8, textAlign: 'left', border: '1px solid #ccc' }}>見積No</th>
              <th style={{ padding: 8, textAlign: 'left', border: '1px solid #ccc' }}>顧客</th>
              <th style={{ padding: 8, textAlign: 'left', border: '1px solid #ccc' }}>件名</th>
              <th style={{ padding: 8, textAlign: 'right', border: '1px solid #ccc' }}>金額</th>
              <th style={{ padding: 8, border: '1px solid #ccc' }}>操作</th>
            </tr>
          </thead>
          <tbody>
            {estimates.map((e) => (
              <tr key={e.id}>
                <td style={{ padding: 8, border: '1px solid #ccc' }}>{e.doc_no}</td>
                <td style={{ padding: 8, border: '1px solid #ccc' }}>{e.customer_name}</td>
                <td style={{ padding: 8, border: '1px solid #ccc' }}>{e.project_name}</td>
                <td style={{ padding: 8, textAlign: 'right', border: '1px solid #ccc' }}>
                  ¥{Number(e.total || 0).toLocaleString()}
                </td>
                <td style={{ padding: 8, border: '1px solid #ccc' }}>
                  <button onClick={() => { onSelect(e.id); onClose(); }}>選択</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <button onClick={onClose}>閉じる</button>
        </div>
      </div>
    </div>
  );
}
